import template from './modalRequest.html';
import controller from './modalRequest.controller';
import './modalRequest.scss';

let modalRequestComponent = {
  restrict: 'E',
  bindings: {
    userId: '<',
    userInceptionId: '<',
    startDate: '<',
    addEvent: '&',
    vacationPeriodCount: '<',
    mode: '<',
    periodToEdit: '<',
    originalPeriod: '<',
    isInception: '<',
    openOn: '<',
    requestType: '<',
    isMobileApp: '<',
    openModalEvent: '&',
    yearPagination: '<'
  },
  template,
  controller
};

export default modalRequestComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/modalRequest.component.js